import SearchConfig from '@sun-chemical/system-config/search-config';
import PigmentService from 'services/PigmentService';
import base from 'stores/search-base/actions';
import * as types from './mutation-types';

export default {
  ...base,
  async search({
    state, getters, commit, dispatch
  }) {
    dispatch('setLoadingState', true);
    const result = await PigmentService.search(
      getters.urlFilters,
      getters['user/token'],
      { includeFormulationSuggestions: getters['user/canViewFormulations'] }
    );
    commit(types.SET_RESULTS, result);

    // Check if the search should be tracked, track only for valid search terms
    if (state.trackNextSearch) {
      const searchTerm = getters.urlFilters[SearchConfig.getMap().search_term.param];
      if (typeof searchTerm === 'string'
        && searchTerm.length > 2) {
        dispatch('trackSearch');
      }
    }

    // Track an event for each search
    if (getters.hasActiveFilters) {
      dispatch('generic/trackEvent', {
        category: 'search',
        action: result.total > 0 ? 'search hit' : 'search miss',
        name: {
          params: getters.urlFilters
        },
        value: result.total
      }, { root: true });
    }

    commit(types.SET_TRACK_NEXT_SEARCH, false);
    dispatch('setLoadingState', false);
  },
  async loadMore({ getters, commit, dispatch }) {
    dispatch('setLoadingState', true);
    const result = await PigmentService.loadMore(getters.results.hits.length, getters['user/token']);
    commit(types.ADD_RESULTS, result.hits);
    dispatch('setLoadingState', false);
  }
};
